<style scoped>
.sub-th {
  text-align: center !important;
  border: thin solid rgba(0, 0, 0, 0.2) !important;
  color: black !important;
  font-size: 10px !important;
  white-space: nowrap;
}

.th-ellipsis {
  max-width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center !important;
  border: thin solid rgba(0, 0, 0, 0.2) !important;
  color: black !important;
}
.th-ellipsis:hover {
  text-overflow: clip;
  white-space: normal;
  word-break: break-all;
  width: 100%;
}
.v-data-table-header-mobile {
  display: none !important;
}

.sticky-col {
  position: -webkit-sticky;
  position: sticky;
  background-color: white;
}

.first-col {
  width: 75px;
  left: 0px;
  text-align: center !important;
  border: thin solid rgba(0, 0, 0, 0.2) !important;
  color: black !important;
}
</style>

<template>
  <div>
    <div class="mt-n8 mb-3 ml-6" style="font-size: 1.35rem" color="blue">
      รายงานรายสัปดาห์
      <v-divider class="mt-1"></v-divider>
    </div>
    <div class="mx-5">
      <v-row>
        <v-col cols="12" sm="12" lg="2">
          <v-card elevation="3">
            <v-card-title>
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    :items="ss_data"
                    solo
                    v-model="ss"
                    dense
                    item-text="NAME"
                    item-value="ID"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <!-- <v-autocomplete
                    :items="p_data"
                    v-model="p_type"
                    dense
                    label="ประเภทบุคคล"
                    item-text="TEXT"
                    item-value="VALUE"
                    solo
                  ></v-autocomplete> -->
                  <v-text-field
                    dense
                    solo
                    v-model="fullname"
                    label="ชื่อ - นามสกุล"
                    class="mt-n10"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="mt-n10">
                  <v-autocomplete
                    :items="handi_data"
                    v-model="handi_type"
                    dense
                    label="ประเภทความพิการ"
                    item-text="TEXT"
                    item-value="VALUE"
                    solo
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" class="mt-n10">
                  <v-autocomplete
                    v-model="organization"
                    :items="organization_list"
                    :loading="loading"
                    item-text="NAME"
                    item-value="NAME"
                    placeholder="หน่วยงาน"
                    solo
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" class="mt-n10">
                  <label style="font-size: 0.95rem">ช่วงคะแนน 0 - 280</label>
                  <v-range-slider
                    v-model="range"
                    class="px-0 mx-0 mt-5"
                    max="280"
                    min="0"
                    dense
                    thumb-label="always"
                    thumb-size="24"
                  >
                    <template v-slot:thumb-label="item">
                      {{ item.value }}
                    </template>
                    <template v-slot:prepend>
                      <v-text-field
                        :value="range[0]"
                        class="ma-0 pa-0"
                        hide-details
                        single-line
                        outline
                        dense
                        type="number"
                        style="width: 35px"
                        @change="$set(range, 0, $event)"
                      ></v-text-field>
                    </template>
                    <template v-slot:append>
                      <v-text-field
                        :value="range[1]"
                        class="ma-0 pa-0"
                        dense
                        hide-details
                        single-line
                        type="number"
                        style="width: 35px"
                        @change="$set(range, 1, $event)"
                      ></v-text-field>
                    </template>
                  </v-range-slider>
                </v-col>

                <v-col cols="12">
                  <v-btn
                    style="width: 100%"
                    dark
                    color="#0089D6"
                    @click="search()"
                  >
                    <v-icon left>mdi-magnify</v-icon>ค้นหา
                  </v-btn>
                </v-col>
                <v-col cols="12">
                  <v-btn style="width: 100%" color="warning" @click="clear()">
                    <v-icon left>mdi-close</v-icon>ล้างการค้นหา
                  </v-btn>
                </v-col>
                <v-col cols="12">
                  <v-btn style="width: 100%" color="#fff" @click="export_xls()">
                    <v-icon left>mdi-printer</v-icon>ส่งออก excel
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-title>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" lg="10">
          <v-data-table
            :headers="headers"
            :items="getIndex"
            :items-per-page="15"
            :loading="tbl_load"
            loading-text="กำลังเรียกข้อมูล..."
            class="elevation-2"
          >
            <template v-slot:item.ORGANIZATION="{ item }">
              <div class="text-truncate" style="max-width: 100px">
                {{ item.ORGANIZATION }}
              </div>
            </template>
            <template v-slot:item.FULLNAME="{ item }">
              <div class="text-truncate" style="max-width: 130px">
                {{ item.FULLNAME }}
              </div>
            </template>
            <template v-slot:item.HANDI_TYPE="{ item }">
              <div class="text-truncate" style="max-width: 130px">
                {{ item.HANDI_TYPE }}
              </div>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row> </v-row>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import moment from 'moment';
export default {
  name: "WeeklyScore",
  components: {

  },
  data() {
    return {
      p_type: null,
      loading: true,
      ss_data: [],
      tbl_load: true,
      comp_name: null,
      organization: null,
      range: [0, 280],
      organization_list: [],
      ss: null,
      p_data: ["คนพิการ", "บุคคลทั่วไป", "นจพ."],
      fullname: null,
      handi_type: null,
      handi_data: ["ทางการเคลื่อนไหวหรือทางร่างกาย", "ทางการได้ยินหรือสื่อความหมาย", "ทางการเรียนรู้", "ทางการเห็น", "ทางจิตใจหรือพฤติกรรม", "ทางสติปัญญา", "ทางออทิสติก", "ไม่พิการ"],
      provice: null,
      province_data: [],
      headers: [
        {
          text: "ลำดับ",
          align: "start",
          sortable: false,
          value: "id",
        },
        { text: "ชื่อ - นามสกุล", value: "FULLNAME" },
        { text: "ความพิการ", value: "HANDI_TYPE" },
        { text: "หน่วยงาน", value: "ORGANIZATION" },
        { text: "สัปดาห์ 1", value: "WEEK1" },
        { text: "สัปดาห์ 2", value: "WEEK2" },
        { text: "สัปดาห์ 3", value: "WEEK3" },
        { text: "สัปดาห์ 4", value: "WEEK4" },
        { text: "สัปดาห์ 5", value: "WEEK5" },
        { text: "สัปดาห์ 6", value: "WEEK6" },
        { text: "สัปดาห์ 7", value: "WEEK7" },
        { text: "สัปดาห์ 8", value: "WEEK8" },
        { text: "สัปดาห์ 9", value: "WEEK9" },
        { text: "สัปดาห์ 10", value: "WEEK10" },
        { text: "รวม", value: "TOTAL_SCORE" },
      ],
      tbl_data: []
    }
  },
  created() {
    this.initialApi()
  },
  computed: {
    getIndex() {
      return this.tbl_data.map((item, index) => ({
        ...item,
        id: index + 1,
      }));
    },

  },
  methods: {
    get_organization() {
      this.$guest_api
        .get("/get-organization")
        .then((res) => {
          let result = res.data.data;
          if (result.length > 0) {
            this.organization_list = result;
            this.loading = false;
          }
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    clear() {
      this.fullname = null
      this.handi_type = null
      this.organization = null
      this.range = [0, 280]
      this.api_weekly_score()
    },
    initialApi() {
      this.get_organization()
      this.$token_api
        .get("/get-season-data")
        .then((res) => {
          const result = res.data.data;
          if (result.length > 0) {
            this.ss_data = result
           // this.ss = result[result.length - 1].ID
            this.get_current_season();
          }
        })
        .catch((e) => {
          console.log(e);
        });

    },
     get_current_season() {
      this.$token_api
        .get("/list-season-week")
        .then((res) => {
          const result2 = res.data.data;
          this.ss = result2.Season || 4
          this.api_weekly_score();

        })
        .catch((e) => {
          console.log(e);
        });
    },
    api_weekly_score() {
      this.$token_api.post('/weekly-report', { SEASON: this.ss, FULLNAME: this.fullname, HANDI_TYPE: this.handi_type, ORGANIZATION: this.organization, SCORE_START: this.range[0], SCORE_END: this.range[1] }).then((res) => {
        const result = res.data.data;
        if (result.length > 0) {

          this.tbl_data = result
          this.tbl_load = false;
        } else {
          this.tbl_data = []
          this.tbl_load = false;
        }
      }).catch((e) => {
        this.tbl_load = false;
        console.log(e)
      });
    },
    search() {
      this.api_weekly_score()
    },
    eva_score(x){
      if(x >= 160){
        return "ผ่าน"
      }else{
        return "ไม่ผ่าน"
      }
    },
    export_xls() {
      // this.LOADER(true)
      let data = this.tbl_data
      let xls_json = []
      if (data.length > 0) {
        data.forEach((element, i) => {
          xls_json.push({
            'ลำดับ': i + 1,
            'ชื่อ - นามสกุล': element.FULLNAME,
            'เลขบัตรประชาชน': element.CID,
            'หน่วยงาน': element.ORGANIZATION,
            'ความพิการ': element.HANDI_TYPE,
            'สัปดาห์ที่ 1': element.WEEK1,
            'สัปดาห์ที่ 2': element.WEEK2,
            'สัปดาห์ที่ 3': element.WEEK3,
            'สัปดาห์ที่ 4': element.WEEK4,
            'สัปดาห์ที่ 5': element.WEEK5,
            'สัปดาห์ที่ 6': element.WEEK6,
            'สัปดาห์ที่ 7': element.WEEK7,
            'สัปดาห์ที่ 8': element.WEEK8,
            'สัปดาห์ที่ 9': element.WEEK9,
            'สัปดาห์ที่ 10': element.WEEK10,
            'คะแนน': element.TOTAL_SCORE,
            'เกณฑ์': this.eva_score(element.TOTAL_SCORE)
          });
        });
        const dataWS = XLSX.utils.json_to_sheet(xls_json);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, dataWS);
        XLSX.writeFile(wb, `รายงานสรุปผลคะแนนรายสัปดาห์.xlsx`);
        // this.LOADER(false)
      } else {
        // this.LOADER(false)
        this.$swal({
          title: "ไม่พบข้อมูล",
          icon: "warning",
          text: `กรุณาค้นหาข้อมูลใหม่อีกครั้ง`,
          timer: 2000
        })
      }
    },
  },
};
</script>
